import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"

const columns = (
  toggle,
  handleValidDate,
  handleOrderClick,
  onClickDelete,
  toLowerCase1,
  toggleViewModal,
  designers,
  path
) => {
  const columns = [
    {
      dataField: "",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },

    {
      dataField: "userName",
      text: "User Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: true,
    },

    {
      dataField: "customerNick",
      text: "Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: true,
      // formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "password",
      text: "Password",
      sort: true,
      // Product Name column can't be edit anymore
      editable: true,
      // formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "Designation",
      text: "Designation",
      sort: true,
      // Product Name column can't be edit anymore
       editor: {
              type: Type.SELECT,
              options: [
                {
                  value: "designer",
                  label: "Designer",
                },
                {
                  value: "sales",
                  label: "Sales",
                },
                {
                  value: "Administrate",
                  label: "Administrator",
                },
                {
                  value: "subadmin",
                  label: "SubAdmin",
                },
              ],
            },
      // formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "registerdDate",
      text: "Registration Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.registerdDate),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <div className="d-flex gap-3">
            {/* <Link
              to="#"
              className="text-success"
              onClick={() => onClickDelete(order)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip delay={{ show: 0, hide: 0 }} placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link> */}
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(order)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip delay={{ show: 0, hide: 0 }} placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]
  return columns
}

columns.propTypes = {
  toggle: PropTypes.func,
  designers: PropTypes.object,
  handleValidDate: PropTypes.func,
  handleOrderClick: PropTypes.func,
  onClickDelete: PropTypes.func,
  locationPath: PropTypes.string,
}

export default columns
